module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame 4108@2x(5).png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame%204108%402x(5).png
// module id = 9IBp
// module chunks = 93